import { defineComponent as _defineComponent } from 'vue'
import {ref, useSlots, watch} from "vue";
import {DataTableFilterMeta, DataTableFilterMetaData, DataTablePageEvent, DataTableSortEvent} from "primevue/datatable";
import {PagingModel} from "@/services/model/paging.model";
import {useGlobalFilterStore} from "@/store/global-filter.store";
import {LocalSpinner} from "@/services/model/localSpinner";
import {onBeforeMount} from "@vue/runtime-core";
import {DefaultSortingModel} from "@/services/model/defaultSorting.model";
import {EagerLoadingConfig} from "@/components/commons/EagerLoadingConfig";
import {LazyLoadingConfig} from "@/components/commons/LazyLoadingConfig";
import {DataTableService} from "@/services/data-table.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTableWrapper',
  props: {
  dataKey: {
    type: String,
    default: undefined
  },
  useExternalGlobalFilter: {
    type: Boolean,
    default: true
  },
  eagerLoadingConfig: {
    type: EagerLoadingConfig,
    default: undefined
  },
  lazyLoadingConfig: {
    type: LazyLoadingConfig,
    default: undefined
  },
  expandedRows:{
    type: Array
  },
  paginator: {
    type: Boolean,
    default: true
  },
  rowClass: {
    type: String,
    default: undefined
  },
},
  setup(__props, { expose: __expose }) {
  __expose();


const globalFilter = useGlobalFilterStore();
const expandedRows = ref([]);
const firstRecord = ref(0);

let paging = new PagingModel(["login"]);
const slots = useSlots();

const props = __props;

function getExpandedRows(){
  if(props.expandedRows != undefined){
    return props.expandedRows;
  } else {
    return expandedRows.value;
  }
}

function slotPassed(slotName: string) {
  return slots[slotName];
}

function isLazyLoading(): boolean {
  return props.lazyLoadingConfig != undefined;
}

function getService(): DataTableService | undefined {
  return props.lazyLoadingConfig?.dataTableService;
}

function getValues(): any {
  if (isLazyLoading()) {
    return getService()?.getListDataHolder().elements;
  } else {
    return props.eagerLoadingConfig?.elements;
  }
}

function getAmount(): number | undefined {
  if (isLazyLoading()) {
    return getService()?.getListDataHolder().amount;
  } else {
    return undefined;
  }
}

function getGlobalFilterFields(): string[] | undefined {
  if (isLazyLoading()) {
    return props.lazyLoadingConfig?.globalFilterFields;
  } else {
    return undefined;
  }
}

function getFilters(): DataTableFilterMeta | undefined {
  return props.eagerLoadingConfig?.filters;
}

onBeforeMount(() => {
  if (isLazyLoading() == true) {
    paging = new PagingModel(props.lazyLoadingConfig?.globalFilterFields as string[]);
    if (getService()?.getDefaultSorting() !== undefined) {
      paging.setDefaultSorting(getService()?.getDefaultSorting() as DefaultSortingModel);
    }
    getService()?.fetchListData(paging, true, null);
  }
  if (props.useExternalGlobalFilter == true) {
    watch(() => globalFilter.getFilter, () => onFilterInput());
  }
});

function pageEvent(event: DataTablePageEvent) {
  if (isLazyLoading()) {
    console.log('onPage: ' + JSON.stringify(event, null, 2));
    getService()?.fetchListData(paging.fromDataTablePageEvent(event), true, null);
  }
}

function sortEvent(event: DataTableSortEvent) {
  console.log('onPage: ' + JSON.stringify(event, null, 2));
  if (isLazyLoading()) {
    getService()?.fetchListData(paging.fromDataTableSortEvent(event), true, null);
  }
}

const localSpinner: LocalSpinner = {
  turnOnFunction: () => {
    globalFilter.setIsLoading(true);
  },
  turnOffFunction: () => {
    globalFilter.setIsLoading(false);
  }
};

let timerId = 0;

function onFilterInput() {
  console.log('onFilterInput: ' + globalFilter.getFilter);
  if (isLazyLoading()) {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      getService()?.fetchListData(paging.updateFilter(globalFilter.getFilter), false, localSpinner);
    }, 500);
  } else {
    if (props.eagerLoadingConfig?.filters != undefined) {
      const temp = props.eagerLoadingConfig?.filters['global'] as DataTableFilterMetaData;
      temp.value = globalFilter.getFilter;
    }
  }
}

function reload() {
  console.log('reload: ');
  paging.clearSorting();
  if (getService()?.fetchListData !== undefined) {
    getService()?.fetchListData(paging, true, null);
  }
}


const __returned__ = { globalFilter, expandedRows, firstRecord, get paging() { return paging }, set paging(v) { paging = v }, slots, props, getExpandedRows, slotPassed, isLazyLoading, getService, getValues, getAmount, getGlobalFilterFields, getFilters, pageEvent, sortEvent, localSpinner, get timerId() { return timerId }, set timerId(v) { timerId = v }, onFilterInput, reload }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})